// regulatory / policy banner data
export const regulatoryPolicyList = {
  banner: {
    en: [
      {
        name: 'Hong Kong Capital Markets Update – Issue 4, May 2025 - KPMG China',
        desc: 'On 6 May 2025, the Stock Exchange of Hong Kong Limited (the “Exchange”) and the Securities and Future Commission (the “SFC”) made a joint announcement in relation to the launch of a dedicated Technology Enterprise Channel (“TECH”)',
        linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/05/hk-capital-markets-04-25.html',
        imgSrc: require(`@/assets/img/clientUser/EN/banner01.png`),
        date: ''
      },
      {
        name: 'The implications of the FSTB Sustainability Reporting Roadmap for Hong Kong Companies - KPMG China',
        desc: 'The Financial Services and the Treasury Bureau issued a roadmap for wider adoption of sustainability reporting in Hong Kong',
        linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/05/the-implications-of-the-fstb-sustainability-reporting-roadmap-for-hk-companies.html',
        imgSrc: require(`@/assets/img/clientUser/EN/banner02.png`),
        date: ''
      },
      {
        name: 'China Tax Insight - KPMG China',
        desc: 'These publications provide in-depth tax analysis and practical insights for businesses operating in China’s key economic and industrial sectors.',
        linkUrl: 'https://kpmg.com/cn/en/home/insights/2020/05/china-tax-insights.html',
        imgSrc: require(`@/assets/img/clientUser/EN/banner03.png`),
        date: ''
      },
      {
        name: 'The journey continues: Navigating the road to readiness - KPMG China',
        desc: 'KPMG ESG Assurance Maturity Index 2024',
        linkUrl: 'https://kpmg.com/cn/en/home/insights/2024/05/the-journey-continues-navigating-the-road-to-readiness.html',
        imgSrc: require(`@/assets/img/clientUser/EN/banner04.png`),
        date: ''
      },
      {
        name: 'The HKEX Enhanced Climate Disclosure - KPMG China',
        desc: 'Stay ahead of the game and embrace the new ESG reporting standards',
        linkUrl: 'https://kpmg.com/cn/en/home/insights/2024/04/the-hkex-enhanced-climate-disclosure.html',
        imgSrc: require(`@/assets/img/clientUser/EN/banner05.png`),
        date: ''
      },
      {
        name: 'Personal information protection compliance audit management and response - KPMG China',
        desc: 'KPMG China provides an in-depth understanding of the core requirements of...',
        linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/03/personal-information-protection-compliance-audit-management-and-response.html',
        imgSrc: require(`@/assets/img/clientUser/EN/banner06.png`),
      },
      {
        name: 'Guides to HKFRS financial statements - KPMG China',
        desc: 'Example financial statements for companies incorporated or listed in Hong Kong',
        linkUrl: 'https://kpmg.com/cn/en/home/services/audit/accounting-and-reporting-focus/guides-to-hkfrs-financial-statements.html',
        imgSrc: require(`@/assets/img/clientUser/EN/banner07.png`),
        date: ''
      },
      {
        name: 'Financial Reporting Webinar Series - KPMG China',
        desc: 'Our webinar series cover the latest financial reporting issues and insights on related matters.',
        linkUrl: 'https://kpmg.com/cn/en/home/services/audit/accounting-and-reporting-focus/financial-reporting-webinar-series.html',
        imgSrc: require(`@/assets/img/clientUser/EN/banner08.png`),
        date: ''
      },
    ],
    zh: [
      {
        name: '香港资本市场通讯 – 2025年5月，第4期 - 毕马威中国',
        desc: '2025年5月6日，香港交易及结算所有限公司（“交易所”）和证券及期货事务监察委员会（“证监会”）推出「科企专线」的联合公告',
        linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/05/hk-capital-markets-04-25.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner01.png`),
        date: ''
      },
      {
        name: '澄清《国际可持续披露准则第2号》 - 毕马威中国',
        desc: '《国际可持续披露准则第2号——气候相关披露》（IFRS S2 Climate-related Disclosures，以下简称“IFRS S2”）的针对性修订可能会改变企业的排放披露方式。',
        linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/01/issb-ifrs-s2-climate-amendments.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner02.png`),
        date: ''
      },
      {
        name: '中国税务洞察-毕马威中国',
        desc: '凭借我们丰富的专业知识和经验，为在中国主要经济行业领域运营的企业深度分析中国税务领域变化，并有针对性地提出实践洞察。',
        linkUrl: 'https://kpmg.com/cn/zh/home/insights/2020/05/china-tax-insights.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner03.png`),
        date: ''
      },
      {
        name: '征途未尽，步履不停',
        desc: '随着全球环境、社会与治理（ESG）议程的加速推进，新的披露规则接踵而至，要求企业增加其ESG表现的透明度。为了确保这些信息披露的可靠性，第三方鉴证已成为不可或缺的一环。',
        linkUrl: 'https://kpmg.com/cn/zh/home/insights/2024/05/the-journey-continues-navigating-the-road-to-readiness.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner04.png`),
        date: ''
      },
      {
        name: '港交所优化气候信息披露 - 毕马威中国',
        desc: '随着香港交易所（“港交所”）推出优化的气候信息披露要求，对上市企业而言至关重要的是将与气候影响相关的考量纳入战略规划',
        linkUrl: 'https://kpmg.com/cn/zh/home/insights/2024/04/the-hkex-enhanced-climate-disclosure.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner05.png`),
        date: ''
      },
      {
        name: '《A股上市指南》系列刊物 - 毕马威中国',
        desc: '《前进资本市场-A股上市指南》和《台资企业A股上市指南》',
        linkUrl: 'https://kpmg.com/cn/zh/home/insights/2023/10/guidelines-for-a-share-listing-of-taiwan-funded-enterprises.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner06.png`),
        date: ''
      },
      {
        name: '个人信息保护合规审计管理与应对 - 毕马威中国',
        desc: '2025年2月14日国家互联网信息办公室正式发布《个人信息保护合规审计管理办法》（以下简称“《审计办法》”），自2025年5月1日起施行。',
        linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/03/personal-information-protection-compliance-audit-management-and-response.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner07.png`),
        date: ''
      },
    ]
  },
}

// tech transformation data
export const techTransformationList = {
  en: [
    {
      name: 'Intelligent retail - KPMG China',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/03/intelligent-retail.html',
      imgSrc: require(`@/assets/img/clientUser/EN/Tech_04.png`),
    },
    {
      name: 'The intelligent tech enterprise - KPMG China',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/04/the-intelligent-tech-enterprise.html',
      imgSrc: require(`@/assets/img/clientUser/EN/Tech_05.png`),
    },
    {
      name: 'Intelligent manufacturing - KPMG China',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/05/intelligent-manufacturing.html',
      imgSrc: require(`@/assets/img/clientUser/EN/Tech_06.png`),
    },
    {
      name: 'Intelligent banking - KPMG China',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/02/intelligent-banking-a-blueprint-for-creating-value-through-ai-driven-transformation.html',
      imgSrc: require(`@/assets/img/clientUser/EN/Tech_01.png`),
    },
    {
      name: 'Blueprint for Intelligent Economies - KPMG China',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/01/blueprint-for-intelligent-economies.html',
      imgSrc: require(`@/assets/img/clientUser/EN/Tech_02.png`),
    },
    {
      name: 'Technology – evolving the audit - KPMG China',
      linkUrl: 'https://kpmg.com/cn/en/home/services/audit/tech-enabled-audit/other-technologies-and-tools.html',
      imgSrc: require(`@/assets/img/clientUser/EN/Tech_03.png`),
    },
  ],
  zh: [
    {
      name: '抗衰老产业报告：政策、市场与技术的融合 - 毕马威中国',
      desc: '随着健康技术发展与健康老龄化理念普及，抗衰老产业潜力巨大。本报告解析衰老机制与疾病关联，探讨抗衰老疗法与传统治疗的异同及预防作用，并关注抗衰老市场与银发健康市场的关系及供需动态，提供产业发展洞察。',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/04/anti-aging-industry-report.html',
      imgSrc: require(`@/assets/img/clientUser/CN/Tech_03.png`),
    },
    {
      name: '能源转型投资展望与能源行业洞察 - 毕马威中国',
      desc: '毕马威最新发布《能源转型投资展望与能源行业洞察》报告，探讨能源行业如何通过投资实现能源转型的目标，并为能源企业的投资决策者及合作伙伴提供深入见解。',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/04/energy-transition-investment-outlook.html',
      imgSrc: require(`@/assets/img/clientUser/CN/Tech_04.png`),
    },
    {
      name: '2024毕马威中国金融科技企业双50报告 - 毕马威中国',
      desc: '中央金融工作会议将做好科技金融、绿色金融、普惠金融、养老金融、数字金融“五篇大文章”作为加快建设金融强国、推动金融高质量发展、走中国特色金融发展之路的重要战略任务。',
      linkUrl: 'https://kpmg.com/cn/zh/home/campaigns/2025/01/china-fintech-50-2024.html',
      imgSrc: require(`@/assets/img/clientUser/CN/Tech_01.png`),
    },
    {
      name: '科技──推动审计变革 - 毕马威中国',
      desc: '在当今的数字世界，数据主导着我们的日常生活，并在规划及开展业务方面发挥着核心作用。我们将先进而强大的数据分析能力和数字化创新技术应用于审计',
      linkUrl: 'https://kpmg.com/cn/zh/home/services/audit/tech-enabled-audit/other-technologies-and-tools.html',
      imgSrc: require(`@/assets/img/clientUser/CN/Tech_02.png`),
    },
  ]
}

// insights data 带分页
export const insightsList = {
  en: [
    {
      name: 'Trust, attitudes and use of artificial intelligence: A global study 2025 - KPMG China',
      desc: 'AI has the immense potential to transform lives, boost industries and help tackle some of the most pressing global issues.',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/05/trust-attitudes-and-use-of-artificial-intelligence-a-global-study-2025.html',
      date: '05/21<br />2025'
    },
    {
      name: 'China Life Sciences Sector Overview and Outlook - KPMG China',
      desc: 'From macro economy to life sciences sub-sectors, review the key trends of the sector and future tendency',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/04/china-life-sciences-sector-overview-and-outlook.html',
      date: '04/23<br />2025'
    },
    {
      name: '2025 Hainan Travel Retail Whitepaper - KPMG China',
      desc: 'The Hainan Free Trade Port continues to be a dynamic and exciting hub for travel retail',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/04/2025-hainan-travel-retail-whitepaper.html',
      date: '04/13<br />2025'
    },
    {
      name: 'Hong Kong Employment Outlook 2025 - KPMG China',
      desc: "Headcount Expectations | Salary Outlook | Talent Management",
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/03/hong-kong-employment-outlook-2025.html',
      date: '03/19<br />2025'
    },
    {
      name: 'Hong Kong Trust Industry Spotlight 2025 - KPMG China',
      desc: "In-depth analysis of the key developments, opportunities and challenges surrounding the Hong Kong trust industry",
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/03/hong-kong-trust-industry-spotlight-2025.html',
      date: '03/18<br />2025'
    },
    {
      name: 'KPMG China Future Entrepreneur Award - KPMG China',
      desc: "evaluating the present and leading the future",
      linkUrl: 'https://kpmg.com/cn/en/home/campaigns/2025/03/the-future-entrepreneur-award.html',
      date: '03/13<br />2025'
    },
    {
      name: 'China Economic Monitor: 2025 Q1 - KPMG China',
      desc: "KPMG China today released Q1 edition of the 2025 China Economic Monitor. ",
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/02/china-economic-monitor-q1-2025.html',
      date: '02/19<br />2025'
    },
    {
      name: 'KPMG CEO Outlook - KPMG China',
      desc: 'More than 1,300 global CEOs share their views on geopolitics, return-to-office, ESG and generative AI.',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2024/09/kpmg-2024-ceo-outlook.html',
      date: '12/31<br />2024'
    },
  ],
  zh: [
    {
      name: '新能源企业“出海”系列之启航欧美 - 毕马威中国',
      desc: '当前，全球能源体系正经历百年未有之大变局。碳中和目标驱动下，可再生能源技术迭代加速，能源消费结构向低碳化、电气化深度转型',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/05/europe-and-america-new-energy-market.html',
      date: '05/08<br />2025'
    },
    {
      name: '中国生命科学行业概览及未来展望 - 毕马威中国',
      desc: '过去几年，在新冠疫情、通胀率上升、美联储等央行加息、市场波动以及地缘政治紧张等困难时期，创新药物的推出、对外授权交易的探索',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/04/china-life-sciences-sector-overview-and-outlook.html',
      date: '04/23<br />2025'
    },
    {
      name: '2025年海南自由贸易港白皮书——韧性前行，潜力无限 - 毕马威中国',
      desc: '面对时代的变局，海南需聚焦税制革新、运营管理及AI技术应用等核心领域，以实现旅游零售市场的升级与扩张。',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/04/2025-hainan-travel-retail-whitepaper.html',
      date: '04/13<br />2025'
    },
    {
      name: '2025年香港就业市场展望 - 毕马威中国',
      desc: "在迈入2025年之际，香港特别行政区（“香港”）就业市场形势持续变化，企业面临机遇与挑战并存的发展新格局。近期，我们发布了《2025年香港就业市场展望》报告，为您深入剖析本港人才市场发展的主要趋势。",
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/03/hong-kong-employment-outlook-2025-sc.html',
      date: '03/19<br />2025'
    },
    {
      name: '毕马威中国未来企业家大奖 - 毕马威中国',
      desc: "未来企业家大奖以“放眼当下 引领未来”为主题，强调了传承、突破、创新的重要性，奖项共设“未来企业家年度大奖”“未来卓越家族企业家”“未来杰出新锐企业家”以及“未来非凡巾帼企业家”四大类别。",
      linkUrl: 'https://kpmg.com/cn/zh/home/campaigns/2025/03/the-future-entrepreneur-award.html',
      date: '03/13<br />2025'
    },
    {
      name: '中国经济观察：2025年一季度 - 毕马威中国',
      desc: "毕马威中国今日发布2025年一季度《中国经济观察》报告。报告指出，2024年中国实际GDP增长5%，其中四季度增速超预期上行至5.4%，为全年顺利实现“5%左右”经济增速目标做出了决定性贡献。",
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/02/china-economic-monitor-q1-2025.html',
      date: '02/19<br />2025'
    },
    {
      name: '2024年全球首席执行官展望 - 毕马威中国',
      desc: '2024年9月25日，毕马威发布《全球首席执行官展望》，报告基于对1,300位全球大型企业首席执行官的调研，内容覆盖经济、人才、新兴技术和ESG等多个领域',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2024/09/kpmg-2024-ceo-outlook.html',
      date: '12/31<br />2024'
    },
    {
      name: '2024年中国首席执行官展望 - 毕马威中国',
      desc: '今年是毕马威在全球开展《首席执行官展望》的第十年，我们的《全球首席执行官展望》基于中长期视角，提供了全球企业管理者对未来三年内企业和经济增长的深度见解',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2024/11/2024-china-ceo-outlook.html',
      date: '12/31<br />2024'
    },
    {
      name: '毕马威中国第七届领先汽车科技50 - 毕马威中国',
      desc: '在过去的一年里，中国汽车行业逐步回暖，新能源汽车渗透率持续攀升，乘用车市场高端化智能化转型趋势明显，AI大模型为代表的尖端技术在智能座舱及基础研发等领域得以广泛应用，国家及地方政府也相继出台了一系列政策措施，推动汽车行业高质量发展。',
      linkUrl: 'https://kpmg.com/cn/zh/home/campaigns/2024/11/china-leading-autotech-50.html',
      date: '12/31<br />2024'
    },
  ]
}
